import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Rec extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rec";
    }
}

export function Rec$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Rec", void 0, Rec, Metadata_NumberCategory$reflection());
}

export function Rec_$ctor_Z721C83C5(aName) {
    return new Rec(aName);
}

export class Birth extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth";
    }
}

export function Birth$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Birth", void 0, Birth, Metadata_NumberCategory$reflection());
}

export function Birth_$ctor_Z721C83C5(aName) {
    return new Birth(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Agegroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "agegroup";
    }
}

export function Agegroup$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Agegroup", void 0, Agegroup, Metadata_StringCategory$reflection());
}

export function Agegroup_$ctor_Z721C83C5(aName) {
    return new Agegroup(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Area extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "area";
    }
}

export function Area$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Area", void 0, Area, Metadata_StringCategory$reflection());
}

export function Area_$ctor_Z721C83C5(aName) {
    return new Area(aName);
}

export class Region extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "region";
    }
}

export function Region$reflection() {
    return class_type("Corpora.Ndctrebanken.MetadataCategories.Region", void 0, Region, Metadata_StringCategory$reflection());
}

export function Region_$ctor_Z721C83C5(aName) {
    return new Region(aName);
}

